import { parseBoolean } from '@amazon/vinyl-util'
import { isLocalHost } from '@/core/localHosts'
import { queryParam } from '@/util/queryParams'

// Default on when served from a local dev host (localhost, local.music.amazon.com,
// …) so local runs get debug logging + the error toast without a query flag;
// an explicit `?debug=0`/`?debug=1` still wins on any host.
const debugParam = queryParam('debug')

export const debug = debugParam != null ? parseBoolean(debugParam) : isLocalHost()
